<mat-form-field class="ui-field">
    <mat-label>{{placeholder}}</mat-label>
    <input matInput class="ui-input" type="text" (keyup)="change($event)" [value]="valueInitial" [matAutocomplete]="auto">
</mat-form-field>

<mat-spinner slot="end" class="ui-spinner" [diameter]="15" color="primary"  *ngIf="loading"></mat-spinner>

<mat-autocomplete panelClass="ui-autocomplete" #auto="matAutocomplete" [displayWith]="display.bind(this)" (optionSelected)="selection($event)">
    <mat-option *ngFor="let item of data" [value]="item[value]">{{item[name]}}</mat-option>
</mat-autocomplete>